/**
 * KAN-826: section "Организация" of the list upload form: a file column for
 * each organization field. Server 400 messages of `company_fields` are shown
 * under the section.
 */
import { Label } from '@/components/ui/label';
import { COMPANY_FIELDS } from '@/lib/uploadCompanyFields';
import type { CompanyFieldKey, CompanyFieldsMapping } from '@/types/dataset';
import { SectionErrors } from './SectionErrors';
import { UploadColumnPicker } from './UploadColumnPicker';

interface UploadCompanyFieldsProps {
  value: CompanyFieldsMapping;
  onChange: (key: CompanyFieldKey, column: string) => void;
  headers: string[];
  errors?: string[];
}

export function UploadCompanyFields({
  value,
  onChange,
  headers,
  errors = [],
}: UploadCompanyFieldsProps): JSX.Element {
  return (
    <div data-testid="upload-company-fields" className="bg-white border rounded-lg p-4 space-y-4">
      <div>
        <h3 className="text-base font-medium text-gray-900">Организация</h3>
        <p className="text-sm text-gray-500">
          Реквизиты организации контакта. Поля без колонки не загружаются.
        </p>
      </div>
      {COMPANY_FIELDS.map(({ key, label }) => {
        const id = `company-field-${key}`;
        return (
          <div key={key} className="grid grid-cols-1 sm:grid-cols-2 gap-2 items-start">
            <Label htmlFor={id} className="sm:pt-2">
              {label}
            </Label>
            <UploadColumnPicker
              id={id}
              selectTestId={`company-select-${key}`}
              inputTestId={`company-input-${key}`}
              value={value[key] ?? ''}
              onChange={(column) => onChange(key, column)}
              headers={headers}
            />
          </div>
        );
      })}
      <SectionErrors testId="company-fields-error" errors={errors} />
    </div>
  );
}
